module.exports = "../images/icons/alert-conferma.svg";